import { useRouter } from '@application/utils';
import { MtAnimalsBreederPage } from '@presentation/pages';
import { useState } from 'react';
import { useFormatAnimals } from './api/useFormatAnimals';
import { useGetAnimals } from './api/useGetAnimals';

export const MtAnimalsBreederPageController = () => {
  const { navigateToRoute } = useRouter();
  const [showArchived, setShowArchived] = useState(false);

  const { animals, animalsLoading } = useGetAnimals(showArchived);

  const { formattedAnimals } = useFormatAnimals({
    animals,
    onClick: (event, index) => {
      const litter = animals?.[index];
      const id = litter?.id;
      if (!id) return;
      navigateToRoute('mtAnimals', { params: [id.toString()] });
    },
  });

  return (
    <>
      <MtAnimalsBreederPage
        loading={animalsLoading}
        onAddClick={() => {
          navigateToRoute('mtAnimals', { params: ['new'] });
        }}
        items={formattedAnimals}
        showArchived={showArchived}
        onToggleShowArchived={setShowArchived}
      />
    </>
  );
};
